exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ccm-client-settings--bYfbiil7ZHRxuzlmIeKP5 .ccm-client-settings--1-gPCty6lhYircXL0-27Bd {\n  width: 20%;\n}\n\n.ccm-client-settings--bYfbiil7ZHRxuzlmIeKP5 .ccm-client-settings--3wZU0QzzPNpqtKn0I3jWXq {\n  width: 80%;\n}\n", ""]);

// exports
exports.locals = {
	"programOverviewContainer": "ccm-client-settings--bYfbiil7ZHRxuzlmIeKP5",
	"programOverviewContainer": "ccm-client-settings--bYfbiil7ZHRxuzlmIeKP5",
	"programsList": "ccm-client-settings--1-gPCty6lhYircXL0-27Bd",
	"programsList": "ccm-client-settings--1-gPCty6lhYircXL0-27Bd",
	"programsOverview": "ccm-client-settings--3wZU0QzzPNpqtKn0I3jWXq",
	"programsOverview": "ccm-client-settings--3wZU0QzzPNpqtKn0I3jWXq"
};